var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataDetail
    ? _c(
        "div",
        { attrs: { id: "vp-container" } },
        [
          _c(
            "div",
            {
              staticClass: "popup-new-version",
              class: { show: _vm.showPopupNewVersion }
            },
            [
              _c("p", { staticClass: "popup-text" }, [
                _vm._v("A new version of Visual Programming is available ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "btn-refresh",
                  on: { click: _vm.updateNewVersion }
                },
                [_vm._v("\n      Update Now\n    ")]
              )
            ]
          ),
          _vm._v(" "),
          _vm.name_automation
            ? _c("j-headful", { attrs: { title: _vm.name_automation } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "studio-page-header",
              class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
            },
            [
              _c("div", { staticClass: "header-automation" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("img", {
                    staticClass: "mr-2 cursor-pointer",
                    attrs: {
                      src: require("@/assets/icon/arrow-left.svg"),
                      width: "18",
                      height: "18"
                    },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/visual-programming")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.dataDetail && _vm.dataDetail.trigger.type === "form"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/automation/data_manager.svg"),
                          width: "30",
                          height: "30"
                        }
                      })
                    : _vm.dataDetail && _vm.dataDetail.trigger.type === "event"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/automation/event.svg"),
                          width: "30",
                          height: "30"
                        }
                      })
                    : _vm.dataDetail &&
                      _vm.dataDetail.trigger.type === "function"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/automation/function.svg"),
                          width: "30",
                          height: "30"
                        }
                      })
                    : (_vm.dataDetail &&
                        _vm.dataDetail.trigger.type === "job") ||
                      _vm.dataDetail.trigger.type === "dedicated_job"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/automation/job.svg"),
                          width: "30",
                          height: "30"
                        }
                      })
                    : _c("img", {
                        attrs: {
                          src: require("@/assets/automation/api.svg"),
                          width: "30",
                          height: "30"
                        }
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.updateTitleAutomation,
                          expression: "updateTitleAutomation"
                        }
                      ],
                      staticClass: "header-item ml-2",
                      class: { "header-item--active": _vm.isEditTitleActive }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.dataDetail ? _vm.dataDetail.id : ""))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "title-wrap" }, [
                        _c(
                          "h3",
                          {
                            staticClass: "title-input-label",
                            style: _vm.isEditTitleActive
                              ? { display: "none" }
                              : {},
                            on: { dblclick: _vm.editTitleAutomation }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.name_automation) +
                                "\n              "
                            ),
                            _c("div", { staticClass: "tooltip-component" }, [
                              _vm._v(
                                "\n                Double Click to edit this Title\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name_automation,
                              expression: "name_automation"
                            }
                          ],
                          ref: "titleInput",
                          staticClass: "title-input",
                          style: _vm.isEditTitleActive
                            ? {
                                width:
                                  (_vm.name_automation.length < 72
                                    ? _vm.name_automation.length * 7.5
                                    : 517) + "px",
                                display: "inline-block"
                              }
                            : {},
                          attrs: { type: "text" },
                          domProps: { value: _vm.name_automation },
                          on: {
                            keyup: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k($event.keyCode, "enter", 13, $event.key)
                              ) {
                                return null
                              }
                              _vm.updateTitleAutomation($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name_automation = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-item ml-2" }, [
                    _c("div", { staticClass: "data-source" }, [
                      (_vm.dataDetail &&
                        _vm.dataDetail.trigger.type.includes("api")) ||
                      _vm.dataDetail.trigger.type.includes("webhook")
                        ? _c("div", { staticClass: "method" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.dataDetail.trigger[
                                    _vm.dataDetail.trigger.type
                                  ].method
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.dataDetail &&
                        _vm.dataDetail.trigger.type.includes("api")) ||
                      _vm.dataDetail.trigger.type.includes("webhook")
                        ? _c("div", { staticClass: "base-url" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.baseURL) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataDetail &&
                      !_vm.dataDetail.trigger.type.includes("api") &&
                      !_vm.dataDetail.trigger.type.includes("webhook")
                        ? _c(
                            "p",
                            {
                              staticClass: "name",
                              class: {
                                "mr-0": _vm.dataDetail.trigger.type === "form"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.triggerName) +
                                  "\n            "
                              )
                            ]
                          )
                        : _c("p", { staticClass: "name" }, [
                            _vm._v(
                              "\n              /" +
                                _vm._s(
                                  _vm.dataDetail.trigger[
                                    _vm.dataDetail.trigger.type
                                  ].url
                                ) +
                                "\n            "
                            )
                          ]),
                      _vm._v(" "),
                      _vm.dataDetail && _vm.dataDetail.trigger.type !== "form"
                        ? _c("i", {
                            staticClass: "fa fa-clone copy-icon",
                            on: { click: _vm.copyToClipboard }
                          })
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tags-header",
                      on: {
                        click: function($event) {
                          _vm.openBlockProperties("code-editor", 1)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "mr-1",
                        attrs: {
                          src: require("@/assets/icon/code-editor.svg"),
                          height: "14"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Code Editor")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tags-header",
                      on: {
                        click: function($event) {
                          _vm.openBlockProperties("run-history", 1)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "mr-1",
                        attrs: {
                          src: require("@/assets/icon/run-history.svg"),
                          height: "14"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Run History")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dataDetail &&
                  (_vm.dataDetail.trigger.type === "job" ||
                    _vm.dataDetail.trigger.type === "dedicated_job")
                    ? _c(
                        "div",
                        {
                          staticClass: "tags-header",
                          on: {
                            click: function($event) {
                              _vm.openBlockProperties("monitoring", 1)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "mr-1",
                            attrs: {
                              src: require("@/assets/icon/monitor.svg"),
                              height: "14"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Job Monitoring")])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataDetail.updated_at
                    ? _c("div", { staticClass: "time-ago m__r--5" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.timeAgo) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.active
                    ? _c("div", { staticClass: "vp-on" }, [
                        _vm._v("\n          ON\n        ")
                      ])
                    : _c("div", { staticClass: "vp-off" }, [
                        _vm._v("\n          OFF\n        ")
                      ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fa fa-ellipsis-v fa-lg cursor-pointer m__l--10 m__t--4",
                    staticStyle: { color: "#4A4A4A" },
                    attrs: { id: "configPopover" }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showBlockAutomation
            ? _c(
                "div",
                { staticClass: "studio-page-content vp-page-content" },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modeAutomation === "diagram",
                          expression: "modeAutomation === 'diagram'"
                        }
                      ],
                      staticClass: "body-automation cursor-grab"
                    },
                    [
                      _c(
                        "j-pan-zoom",
                        {
                          ref: "zoomWrapper",
                          attrs: {
                            options: _vm.zoomOptions,
                            selector: ".zoomable"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "zoomable wrap-layer" },
                            [
                              _c("j-automation-trigger", {
                                ref: "automationTrigger",
                                attrs: { "data-edit": _vm.dataDetail }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "hierarchy-line-vertical"
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "hierarchy-line-arrow-down"
                              }),
                              _vm._v(" "),
                              _c("diagram-view", {
                                attrs: {
                                  "data-actions": _vm.data_automation,
                                  row: 1
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn-action-add-automation-plus",
                                  attrs: { id: "automationAdd" },
                                  on: {
                                    click: function($event) {
                                      _vm.openPopoverAdd("popoverAddAutomation")
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-plus" })]
                              ),
                              _vm._v(" "),
                              _vm.popoverAddBlock &&
                              _vm.popoverAddBlock === "popoverAddAutomation"
                                ? _c(
                                    "b-popover",
                                    {
                                      ref: "popoverAddAutomation",
                                      attrs: {
                                        target: "automationAdd",
                                        triggers: "click",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c("ModalListAction", {
                                        directives: [
                                          {
                                            name: "click-outside",
                                            rawName: "v-click-outside",
                                            value: _vm.hideAllPopoverAdd,
                                            expression: "hideAllPopoverAdd"
                                          }
                                        ],
                                        on: { select: _vm.selectActionBlock }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "wrap-zoom",
                          class: {
                            "wrap-zoom-no-sidebar": !_vm.is_sidebar_minimized
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "zoom-btn",
                              on: {
                                click: function($event) {
                                  _vm.handleZoom("zoomin")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-plus" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "zoom-btn",
                              on: {
                                click: function($event) {
                                  _vm.handleZoom("zoomout")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-minus" })]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modeAutomation === "diagram",
                          expression: "modeAutomation === 'diagram'"
                        }
                      ],
                      staticClass:
                        "container-properties-automation block-action",
                      class: {
                        "show-container-properties-automation":
                          _vm.propertiesOpened,
                        "hide-container-properties-automation": !_vm.propertiesOpened
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between"
                        },
                        [
                          _c("div", { staticClass: "header-properties-wrap" }, [
                            _c("div", { staticClass: "label-log-detail" }, [
                              _vm._v("Properties")
                            ]),
                            _vm._v(" "),
                            _vm.propertiesTypeBlock === "trigger"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--5 m__l--12",
                                    attrs: {
                                      src: require("@/assets/automation/trigger.png"),
                                      width: "15"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "title-automation m__r--5" },
                                    [_vm._v("TRIGGER")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.propertiesTypeBlock === "action"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--5 m__l--12",
                                    attrs: {
                                      src: require("@/assets/automation/action-lg.png"),
                                      width: "15"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "title-automation m__r--5" },
                                    [_vm._v("ACTION")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.propertiesTypeBlock === "conditional"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--5 m__l--12",
                                    attrs: {
                                      src: require("@/assets/automation/conditional.svg"),
                                      width: "15"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "title-automation m__r--5" },
                                    [_vm._v("CONDITIONAL")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.propertiesTypeBlock === "while"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--5 m__l--12",
                                    attrs: {
                                      src: require("@/assets/automation/while.svg"),
                                      width: "15"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "title-automation m__r--5" },
                                    [_vm._v("WHILE")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.propertiesTypeBlock === "javascript"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "m__r--5 m__l--12",
                                    attrs: {
                                      src: require("@/assets/automation/script.svg"),
                                      width: "15"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "title-automation m__r--5" },
                                    [_vm._v("SCRIPT")]
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _vm.propertiesTypeBlock === "javascript"
                                ? _c("img", {
                                    staticClass: "toggle-fullscreen",
                                    attrs: {
                                      src: require("@/assets/icon/fullscreen.svg"),
                                      alt: "fullscreen"
                                    },
                                    on: { click: _vm.fullscreenBlock }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "close-properties-automation",
                                  on: { click: _vm.hideProperties }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/icon-close-properties.svg"),
                                      width: "25"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.propertiesOpened &&
                      _vm.propertiesTypeBlock === "trigger"
                        ? _c("j-automation-trigger", {
                            ref: "automationTriggerPro",
                            attrs: {
                              "data-edit": _vm.dataDetail,
                              "on-properties": true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.propertiesOpened &&
                      _vm.propertiesTypeBlock === "javascript"
                        ? _c("j-automation-javascript", {
                            ref: "automationJavascriptPro",
                            attrs: {
                              id: _vm.propertiesIDBlock,
                              "data-edit": _vm.propertiesDataBlock,
                              "data-history": _vm.historyActionBlockScript,
                              "on-properties": true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.propertiesOpened &&
                      _vm.propertiesTypeBlock === "action"
                        ? _c("j-automation-action", {
                            ref: "automationActionPro",
                            attrs: {
                              id: _vm.propertiesIDBlock,
                              "data-edit": _vm.propertiesDataBlock,
                              "on-properties": true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.propertiesOpened &&
                      _vm.propertiesTypeBlock === "conditional"
                        ? _c("j-automation-conditional", {
                            ref: "automationConditionalPro",
                            attrs: {
                              id: _vm.propertiesIDBlock,
                              "data-edit": _vm.propertiesDataBlock,
                              "on-properties": true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.propertiesOpened &&
                      _vm.propertiesTypeBlock === "while"
                        ? _c("j-automation-while", {
                            ref: "automationWhilePro",
                            attrs: {
                              id: _vm.propertiesIDBlock,
                              "data-edit": _vm.propertiesDataBlock,
                              "on-properties": true
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "privilege-data-manager-access-button",
                          class: {
                            "show-privilege-data-manager-access-button":
                              _vm.propertiesOpened,
                            "hide-privilege-data-manager-access-button": !_vm.propertiesOpened,
                            "justify-content-end":
                              _vm.propertiesTypeBlock === "trigger" ||
                              !_vm.propertiesDataBlock
                          }
                        },
                        [
                          _vm.propertiesTypeBlock !== "trigger" &&
                          _vm.propertiesDataBlock
                            ? _c(
                                "button",
                                {
                                  staticClass: "button-border",
                                  on: { click: _vm.deleteBlockAutomation }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-trash" }),
                                  _vm._v(" Delete\n        ")
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button-border mr-2",
                                  on: { click: _vm.hideProperties }
                                },
                                [_vm._v("\n            Close\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "button-blue",
                                  on: { click: _vm.updateBlockAutomation }
                                },
                                [_vm._v("\n            Update\n          ")]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.modeAutomation === "code"
                    ? _c("div", {
                        staticClass: "body-automation block-log p--15"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modeAutomation === "job-monitoring"
                    ? _c(
                        "div",
                        { staticClass: "p--15" },
                        [
                          _c("jVPJobMonitoring", {
                            attrs: { id: _vm.visprogId }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modeAutomation === "dedicated-job-monitoring"
                    ? _c(
                        "div",
                        { staticClass: "p--15" },
                        [
                          _c("jVPDedicatedJobMonitoring", {
                            attrs: { id: _vm.visprogId }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modeAutomation === "log"
                    ? _c(
                        "div",
                        { staticClass: "body-automation block-log p--15" },
                        [
                          !_vm.isBlockLog
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "label-log-history" },
                                    [
                                      _vm._v(
                                        "Visual Programming Running History"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.showDataTable && !_vm.load_first
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                          staticStyle: {
                                            height: "400px",
                                            width: "100%"
                                          }
                                        },
                                        [_vm._m(0)]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showDataTable
                                    ? _c(
                                        "v-server-table",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.load_first,
                                              expression: "load_first"
                                            }
                                          ],
                                          ref: "automationLogComponent",
                                          staticClass:
                                            "jTable table-run-history",
                                          attrs: {
                                            columns: _vm.columns,
                                            options: _vm.table_options
                                          },
                                          on: {
                                            loading: _vm.loading,
                                            loaded: _vm.loaded
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "status",
                                              fn: function(props) {
                                                return _c("div", {}, [
                                                  _c("img", {
                                                    staticClass: "m__r--5",
                                                    attrs: {
                                                      src: require("@/assets/log/" +
                                                        props.row.status +
                                                        ".png")
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n            " +
                                                      _vm._s(
                                                        props.row.status ===
                                                          "success"
                                                          ? "Ran successfully"
                                                          : props.row.status ===
                                                            "running"
                                                          ? "Running"
                                                          : "Ran error"
                                                      ) +
                                                      "\n          "
                                                  )
                                                ])
                                              }
                                            },
                                            {
                                              key: "runtime",
                                              fn: function(props) {
                                                return _c("div", {}, [
                                                  _vm._v(
                                                    "\n            " +
                                                      _vm._s(
                                                        props.row.runtime
                                                      ) +
                                                      " ms\n          "
                                                  )
                                                ])
                                              }
                                            },
                                            {
                                              key: "time",
                                              fn: function(props) {
                                                return _c("div", {}, [
                                                  _vm._v(
                                                    "\n            " +
                                                      _vm._s(
                                                        _vm.convertDateTime(
                                                          props.row.time
                                                        )
                                                      ) +
                                                      "\n          "
                                                  )
                                                ])
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "custom-search",
                                              attrs: { slot: "beforeFilter" },
                                              slot: "beforeFilter"
                                            },
                                            [
                                              _c(
                                                "b-form",
                                                { attrs: { inline: "" } },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "btn grey btn-import-form",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.$refs.automationLogComponent.refresh()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-refresh"
                                                      }),
                                                      _vm._v(
                                                        " Refresh\n              "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "custom-pagination" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-previous",
                                          on: { click: _vm.previousPage }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-chevron-left"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-forward",
                                          on: { click: _vm.forwardPage }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-chevron-right"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isBlockLog
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-arrow-left cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.isBlockLog = false
                                          _vm.showLogDetail = false
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "info-selected-block" },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.historyDetail.running_id
                                            ) +
                                            " "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.convertDateTime(
                                                _vm.historyDetail.time
                                              )
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "label-log-history" },
                                    [
                                      _vm._v(
                                        "Block Visual Programming Running History"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-client-table", {
                                    staticClass: "jTable",
                                    attrs: {
                                      data: _vm.dataListBlockLog,
                                      columns: _vm.columns_block,
                                      options: _vm.table_options_block
                                    },
                                    on: { "row-click": _vm.openDetailBlockLog },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "status",
                                        fn: function(props) {
                                          return _c("div", {}, [
                                            _c("img", {
                                              staticClass: "m__r--5",
                                              attrs: {
                                                src: require("@/assets/log/" +
                                                  props.row.status +
                                                  ".png")
                                              }
                                            }),
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  props.row.status === "success"
                                                    ? "Ran successfully"
                                                    : props.row.status ===
                                                      "running"
                                                    ? "Running"
                                                    : "Ran error"
                                                ) +
                                                "\n          "
                                            )
                                          ])
                                        }
                                      },
                                      {
                                        key: "runtime",
                                        fn: function(props) {
                                          return _c("div", {}, [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(props.row.runtime) +
                                                " ms\n          "
                                            )
                                          ])
                                        }
                                      },
                                      {
                                        key: "time",
                                        fn: function(props) {
                                          return _c("div", {}, [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.convertDateTime(
                                                    props.row.time
                                                  )
                                                ) +
                                                "\n          "
                                            )
                                          ])
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "container-log-detail",
                              class: {
                                "show-container-log-detail": _vm.showLogDetail,
                                "hide-container-log-detail": !_vm.showLogDetail
                              }
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "6" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "label-log-detail" },
                                      [_vm._v("Log Detail")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { md: "6" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "close-properties-automation pull-right",
                                        on: {
                                          click: function($event) {
                                            _vm.showLogDetail = false
                                          }
                                        }
                                      },
                                      [_vm._v("X")]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showLogDetail && _vm.logDetail
                                ? _c(
                                    "div",
                                    { staticClass: "label-id-log-detail" },
                                    [
                                      _vm._v(
                                        "\n          #" +
                                          _vm._s(_vm.logDetail.action_id) +
                                          " - " +
                                          _vm._s(_vm.logDetail.type) +
                                          "\n        "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLogDetail && _vm.logDetail
                                ? _c(
                                    "div",
                                    { staticClass: "label-id-log-detail" },
                                    [
                                      _vm._v("\n          Runtime : "),
                                      _c(
                                        "span",
                                        { staticClass: "runtime-log-detail" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.logDetail.runtime) +
                                              " ms"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLogDetail && _vm.loadLogDetailData
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center align-items-center",
                                      staticStyle: {
                                        height: "400px",
                                        width: "100%"
                                      }
                                    },
                                    [_vm._m(1)]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLogDetail &&
                              !_vm.loadLogDetailData &&
                              _vm.logDetail.warning
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "container-warning-log-detail"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "label-warning-log-detail"
                                        },
                                        [_vm._v("WARNING")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "warning-log-detail" },
                                        [_vm._v(_vm._s(_vm.logDetail.warning))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLogDetail &&
                              !_vm.loadLogDetailData &&
                              _vm.logDetail.status === "error"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "container-error-log-detail"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "label-error-log-detail"
                                        },
                                        [_vm._v("ERROR")]
                                      ),
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(_vm.logDetail.error) +
                                          "\n        "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLogDetail && !_vm.loadLogDetailData
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "container-data-log-detail"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "label-data-log-detail"
                                        },
                                        [_vm._v("DATA")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "pre",
                                        { staticClass: "debug-log-detail" },
                                        [_vm._v(_vm._s(_vm.logDetail.data))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn-close-log-detail",
                                  on: {
                                    click: function($event) {
                                      _vm.showLogDetail = false
                                    }
                                  }
                                },
                                [_vm._v("Close")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideAllPopover,
                  expression: "hideAllPopover"
                }
              ],
              ref: "configPopoverRef",
              attrs: {
                show: _vm.configPopoverShow,
                target: "configPopover",
                placement: "left"
              },
              on: {
                "update:show": function($event) {
                  _vm.configPopoverShow = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "add-automation",
                  on: { click: _vm.configAutomation }
                },
                [_vm._v("Config")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-automation",
                  on: { click: _vm.removeAutomation }
                },
                [_vm._v("Delete")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "configModal",
              staticClass: "mod-form",
              attrs: {
                centered: "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "label-create-form-data font-weight-bold mb-4" },
                [_vm._v("CONFIG VISUAL PROGRAMMING")]
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.name_automation.$error } },
                [
                  _c("label", { attrs: { for: "name" } }, [_vm._v(" Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      id: "name",
                      "error-required": _vm.$v.name_automation.$error,
                      placeholder: "Enter name here"
                    },
                    model: {
                      value: _vm.$v.name_automation.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.name_automation, "$model", $$v)
                      },
                      expression: "$v.name_automation.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { class: { "error-input": _vm.$v.description.$error } },
                [
                  _c("label", { attrs: { for: "description" } }, [
                    _vm._v(" Description ")
                  ]),
                  _vm._v(" "),
                  _c("j-textarea", {
                    attrs: {
                      "error-required": _vm.$v.description.$error,
                      "max-length": 255,
                      placeholder: "Enter description here"
                    },
                    model: {
                      value: _vm.$v.description.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.description, "$model", $$v)
                      },
                      expression: "$v.description.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Active ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            model: {
                              value: _vm.active,
                              callback: function($$v) {
                                _vm.active = $$v
                              },
                              expression: "active"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.dataDetail && _vm.dataDetail.trigger.type === "form"
                    ? _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", [_vm._v(" Synchronous ")]),
                              _vm._v(" "),
                              _c("j-toggle", {
                                model: {
                                  value: _vm.is_sync,
                                  callback: function($$v) {
                                    _vm.is_sync = $$v
                                  },
                                  expression: "is_sync"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Disable Run History ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            model: {
                              value: _vm.disable_run_history,
                              callback: function($$v) {
                                _vm.disable_run_history = $$v
                              },
                              expression: "disable_run_history"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "float-right m__t--20" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn m__r--5",
                      on: { click: _vm.closeConfigAutomation }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn blue",
                      on: { click: _vm.updateConfigAutomation }
                    },
                    [_vm._v("\n        Update\n      ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modalFullScript",
              staticClass: "mod-full-block",
              attrs: {
                centered: "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "modal-fullscreen" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between"
                    },
                    [
                      _c("div", { staticClass: "label-log-detail" }, [
                        _vm._v("Properties")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("img", {
                          staticClass: "toggle-fullscreen",
                          attrs: {
                            src: require("@/assets/icon/minimize.svg"),
                            alt: "fullscreen"
                          },
                          on: { click: _vm.minimizeBlock }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "close-properties-automation",
                            on: { click: _vm.hidePropertiesFull }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/icon/icon-close-properties.svg"),
                                width: "25"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showModalFullscreen
                    ? _c("j-automation-javascript", {
                        ref: "automationJavascriptFullPro",
                        attrs: {
                          "data-edit": _vm.propertiesDataBlock,
                          "data-history": _vm.historyActionBlockScript,
                          "on-properties": true,
                          "on-fullscreen": true
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-update-properties-automation",
                      on: { click: _vm.updateBlockAutomation }
                    },
                    [_vm._v("Update")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-close-properties-automation",
                      on: { click: _vm.hidePropertiesFull }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-delete-properties-automation",
                      on: { click: _vm.deleteBlockAutomation }
                    },
                    [_vm._v("Delete")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.showModalCodeEditor
            ? _c(
                "div",
                {
                  staticClass: "container-modal-code-editor",
                  attrs: { id: "modal-code-editor" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "close-properties-automation float-right",
                      on: {
                        click: function($event) {
                          _vm.toggleModalCodeEditor(false)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/icon-close-properties.svg"),
                          width: "25"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "btn-apply-action-automation d-block m-0",
                      on: { click: _vm.applyOnlyAutomation }
                    },
                    [_vm._v("\n      Apply\n    ")]
                  ),
                  _vm._v(" "),
                  _vm.showCodeEditor
                    ? _c("j-monaco-editor", {
                        ref: "scriptEditor",
                        staticClass: "m__t--20",
                        attrs: { value: _vm.jsonData, language: "json" }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showModalMonitoring
            ? _c(
                "div",
                {
                  staticClass: "container-modal-code-editor",
                  attrs: { id: "modal-monitoring" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "close-properties-automation float-right",
                      on: {
                        click: function($event) {
                          _vm.toggleModalMonitoring(false)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/icon-close-properties.svg"),
                          width: "25"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.dataDetail &&
                          _vm.dataDetail.trigger.type === "dedicated_job"
                          ? "Dedicated"
                          : ""
                      ) + " Job Monitoring"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.dataDetail && _vm.dataDetail.trigger.type === "job"
                    ? _c("jVPJobMonitoring", { attrs: { id: _vm.visprogId } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataDetail &&
                  _vm.dataDetail.trigger.type === "dedicated_job"
                    ? _c("jVPDedicatedJobMonitoring", {
                        attrs: { id: _vm.visprogId }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "container-properties-automation block-properties-run-history stack-1",
              class: {
                "show-container-properties-automation":
                  _vm.showBlockProperties && !_vm.showBlockStack2Properties,
                "hide-container-properties-automation": !_vm.showBlockProperties,
                "show-container-properties-stack-2-automation":
                  _vm.showBlockStack2Properties &&
                  !_vm.showBlockStack3Properties,
                "show-container-properties-stack-3-automation":
                  _vm.showBlockStack3Properties
              },
              attrs: { id: "data-list-history" }
            },
            [
              _c("div", { staticClass: "header-properties-vp-wrap" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "reload-data-run-history",
                      on: { click: _vm.getDataRunHistory }
                    },
                    [
                      _c("img", {
                        style: _vm.imageStyleRotate,
                        attrs: {
                          src: require("@/assets/icon/reload.png"),
                          height: "16"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "close-properties-automation",
                      on: {
                        click: function($event) {
                          _vm.showBlockProperties = false
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/icon-close-properties.svg"),
                          width: "25"
                        }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "list-data-run-history",
                  attrs: { id: "list-data-run-history" }
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-filter-log mb-3",
                      class: {
                        "btn-filter-log--active": !!_vm.filterLog
                      },
                      attrs: { id: "filterLogList" },
                      on: { click: _vm.openPopoverFilterLog }
                    },
                    [
                      _c("i", { staticClass: "fa fa-filter" }),
                      _vm._v(" Filter\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      ref: "popoverFilterLog",
                      attrs: {
                        show: _vm.popoverFilterLogShow,
                        target: "filterLogList",
                        container: "list-data-run-history",
                        triggers: "click",
                        placement: "bottom",
                        title: "Filter"
                      },
                      on: {
                        "update:show": function($event) {
                          _vm.popoverFilterLogShow = $event
                        }
                      }
                    },
                    [
                      _c("j-popover-filter-run-history", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.closePopoverFilterLog,
                            expression: "closePopoverFilterLog"
                          }
                        ],
                        on: {
                          "apply-filter": _vm.handleFilterLog,
                          "reset-filter": _vm.resetFilterLog
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isLoadingListLog
                    ? _vm._l(5, function(i) {
                        return _c("div", {
                          key: i,
                          staticClass: "skeleton-list-log"
                        })
                      })
                    : !_vm.isLoadingListLog && _vm.dataListRunHistory.length > 0
                    ? _vm._l(_vm.dataListRunHistory, function(view) {
                        return _c(
                          "div",
                          {
                            key: view.id,
                            staticClass: "item-data-run-history"
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/automation/history.svg"),
                                width: "20"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-data-run-history__label" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-data-run-history__label-id"
                                  },
                                  [_vm._v(_vm._s(view.id))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-data-run-history__label-time"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.convertDateTime(view.time))
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "item-data-run-history__div-runtime"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-data-run-history__label-runtime"
                                  },
                                  [_vm._v("Total Runtime")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-data-run-history__runtime"
                                  },
                                  [_vm._v(_vm._s(view.runtime) + " ms")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/assets/log/" +
                                  view.status +
                                  ".png"),
                                height: "23",
                                width: "23"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  "item-data-run-history__status " + view.status
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      view.status === "success"
                                        ? "SUCCESS"
                                        : view.status === "running"
                                        ? "RUNNING"
                                        : "ERROR"
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "item-data-run-history__icon-fa",
                                on: {
                                  click: function($event) {
                                    _vm.openBlockProperties(
                                      "run-history",
                                      2,
                                      view
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-chevron-right" })]
                            )
                          ]
                        )
                      })
                    : !_vm.isLoadingListLog &&
                      _vm.dataListRunHistory.length === 0
                    ? _c("div", { staticClass: "list-not-found" }, [
                        _vm._v("\n        There are no items to show.\n      ")
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "container-properties-automation block-properties-run-history stack-2",
              class: {
                "show-container-properties-automation":
                  _vm.showBlockStack2Properties &&
                  !_vm.showBlockStack3Properties,
                "hide-container-properties-automation": !_vm.showBlockStack2Properties,
                "show-container-properties-stack-2-automation":
                  _vm.showBlockStack3Properties
              }
            },
            [
              _c("div", { staticClass: "header-properties-vp-wrap" }, [
                _c("i", {
                  staticClass: "fa fa-arrow-left cursor-pointer",
                  on: {
                    click: function($event) {
                      _vm.showBlockStack2Properties = false
                    }
                  }
                }),
                _vm._v(" "),
                _vm.historyDetail
                  ? _c(
                      "div",
                      { staticClass: "item-data-run-history m__b--0" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/automation/history.svg"),
                            width: "20"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-data-run-history__label" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item-data-run-history__label-id"
                              },
                              [_vm._v(_vm._s(_vm.historyDetail.id))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "item-data-run-history__label-time"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.convertDateTime(_vm.historyDetail.time)
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-data-run-history__div-runtime" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "item-data-run-history__label-runtime"
                              },
                              [_vm._v("Total Runtime")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item-data-run-history__runtime" },
                              [
                                _vm._v(
                                  _vm._s(_vm.historyDetail.runtime) + " ms"
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/log/" +
                              _vm.historyDetail.status +
                              ".png"),
                            height: "23",
                            width: "23"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class:
                              "item-data-run-history__status " +
                              _vm.historyDetail.status
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.historyDetail.status === "success"
                                    ? "SUCCESS"
                                    : _vm.historyDetail.status === "running"
                                    ? "RUNNING"
                                    : "ERROR"
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "reload-data-run-history",
                      on: { click: _vm.getDataBlockLog }
                    },
                    [
                      _c("img", {
                        style: _vm.imageStyleRotate,
                        attrs: {
                          src: require("@/assets/icon/reload.png"),
                          height: "16"
                        }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "list-data-run-history",
                  attrs: { id: "list-detail-data-run-history" }
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-filter-log mb-3",
                      class: {
                        "btn-filter-log--active": !!_vm.filterDetailLog
                      },
                      attrs: { id: "filterDetailLogList" },
                      on: { click: _vm.openPopoverFilterDetailLog }
                    },
                    [
                      _c("i", { staticClass: "fa fa-filter" }),
                      _vm._v(" Filter\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      ref: "popoverFilterDetailLog",
                      attrs: {
                        show: _vm.popoverFilterDetailLogShow,
                        target: "filterDetailLogList",
                        container: "list-detail-data-run-history",
                        triggers: "click",
                        placement: "bottom",
                        title: "Filter"
                      },
                      on: {
                        "update:show": function($event) {
                          _vm.popoverFilterDetailLogShow = $event
                        }
                      }
                    },
                    [
                      _c("j-popover-filter-run-history", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.popoverFilterDetailLogShow,
                            expression: "popoverFilterDetailLogShow"
                          }
                        ],
                        attrs: { "is-filter-detail": true },
                        on: {
                          "apply-filter": _vm.handleFilterDetailLog,
                          "reset-filter": _vm.resetFilterDetailLog
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isLoadingListDetailLog
                    ? _vm._l(5, function(i) {
                        return _c("div", {
                          key: i,
                          staticClass: "skeleton-list-log"
                        })
                      })
                    : !_vm.isLoadingListDetailLog &&
                      _vm.dataListBlockLog.length > 0
                    ? _vm._l(_vm.dataListBlockLog, function(view, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "item-data-block-run-history"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "item-data-run-history" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/automation/history.svg"),
                                    width: "20"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-data-run-history__label"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-data-run-history__label-id"
                                      },
                                      [_vm._v(_vm._s(view.id))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-data-run-history__label-time"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.convertDateTime(view.time))
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-data-run-history__div-runtime"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-data-run-history__label-runtime"
                                      },
                                      [_vm._v("Runtime")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "item-data-run-history__runtime"
                                      },
                                      [_vm._v(_vm._s(view.runtime) + " ms")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/log/" +
                                      view.status +
                                      ".png"),
                                    height: "23",
                                    width: "23"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class:
                                      "item-data-run-history__status " +
                                      view.status
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          view.status === "success"
                                            ? "SUCCESS"
                                            : view.status === "running"
                                            ? "RUNNING"
                                            : "ERROR"
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass:
                                    "item-data-run-history__open-tab",
                                  attrs: {
                                    src: require("@/assets/automation/open-tab.png"),
                                    width: "20",
                                    height: "20"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.openBlockProperties(
                                        "run-history",
                                        3,
                                        view,
                                        index
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "item-data-run-history-info-type"
                              },
                              [
                                _c("img", {
                                  staticClass: "m__r--5",
                                  attrs: {
                                    src: require("@/assets/automation/" +
                                      _vm.getIconBlockLog(view, index) +
                                      ".svg"),
                                    width: "20",
                                    height: "20"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "title-automation m__r--5" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getNameBlockLog(view, index))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "id-block-automation" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        view.action_id
                                          ? "#" + view.action_id
                                          : ""
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      })
                    : !_vm.isLoadingListDetailLog &&
                      _vm.dataListBlockLog.length === 0
                    ? _c("div", { staticClass: "list-not-found" }, [
                        _vm._v("\n        There are no items to show.\n      ")
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "container-properties-automation block-properties-run-history stack-3",
              class: {
                "show-container-properties-automation":
                  _vm.showBlockStack3Properties,
                "hide-container-properties-automation": !_vm.showBlockStack3Properties
              }
            },
            [
              _vm.logDetail
                ? _c("div", { staticClass: "item-data-run-history m__b--0" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/automation/history.svg"),
                        width: "20"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-data-run-history__label" }, [
                      _c(
                        "div",
                        { staticClass: "item-data-run-history__label-id" },
                        [_vm._v(_vm._s(_vm.logDetail.id))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-data-run-history__label-time" },
                        [
                          _vm._v(
                            _vm._s(_vm.convertDateTime(_vm.logDetail.time))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-data-run-history__div-runtime" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "item-data-run-history__label-runtime"
                          },
                          [_vm._v("Runtime")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-data-run-history__runtime" },
                          [_vm._v(_vm._s(_vm.logDetail.runtime) + " ms")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/log/" +
                          _vm.logDetail.status +
                          ".png"),
                        height: "23",
                        width: "23"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "item-data-run-history__status " +
                          _vm.logDetail.status
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.logDetail.status === "success"
                                ? "SUCCESS"
                                : _vm.logDetail.status === "running"
                                ? "RUNNING"
                                : "ERROR"
                            ) +
                            "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "close-properties-automation",
                        on: {
                          click: function($event) {
                            _vm.showBlockStack3Properties = false
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/icon/icon-close-properties.svg"),
                            width: "25"
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "list-data-run-history" }, [
                _vm.showLogDetail && _vm.logDetail
                  ? _c(
                      "div",
                      { staticClass: "item-data-run-history-info-type" },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("img", {
                            staticClass: "m__r--5",
                            attrs: {
                              src: require("@/assets/automation/" +
                                _vm.getIconBlockLog(
                                  _vm.logDetail,
                                  _vm.indexBlockLogSelected
                                ) +
                                ".svg"),
                              width: "20",
                              height: "20"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "title-automation m__r--5" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getNameBlockLog(
                                    _vm.logDetail,
                                    _vm.indexBlockLogSelected
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "id-block-automation" }, [
                            _vm._v(
                              _vm._s(
                                _vm.logDetail.action_id
                                  ? "#" + _vm.logDetail.action_id
                                  : ""
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.dataDetail.trigger.type === "form" &&
                        _vm.indexBlockLogSelected === 0
                          ? _c("div", { staticClass: "info-data-manager" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/automation/data_manager.svg"),
                                  width: "20",
                                  height: "20"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "m__l--5" }, [
                                _c(
                                  "div",
                                  { staticClass: "label-form-data-name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dataDetail.trigger.form
                                          .form_data_name
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "label-event" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataDetail.trigger.form.event.replace(
                                        "_",
                                        " "
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("label", [_vm._v("Result")]),
                _vm._v(" "),
                _vm.showLogDetail && _vm.loadLogDetailData
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center",
                        staticStyle: { height: "400px", width: "100%" }
                      },
                      [_vm._m(3)]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLogDetail &&
                !_vm.loadLogDetailData &&
                _vm.logDetail.warning
                  ? _c("div", { staticClass: "container-warning-log-detail" }, [
                      _c("div", { staticClass: "warning-log-detail" }, [
                        _vm._v(_vm._s(_vm.logDetail.warning))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLogDetail &&
                !_vm.loadLogDetailData &&
                _vm.logDetail.status === "error"
                  ? _c("div", { staticClass: "container-error-log-detail" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.logDetail.error) + "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLogDetail && !_vm.loadLogDetailData
                  ? _c("div", { staticClass: "container-data-log-detail" }, [
                      _c("pre", { staticClass: "debug-log-detail" }, [
                        _vm._v(_vm._s(_vm.logDetail.data))
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-properties-wrap" }, [
      _c("div", { staticClass: "label-log-detail" }, [_vm._v("Run History")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380ddfd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380ddfd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPMain.vue
// module id = null
// module chunks = 